import 'font-awesome/css/font-awesome.min.css';
export * from './item/item';
export * from './container';
export * from './item-title/item-title';
export * from './item-details/item-details';
